import { defineMessages } from 'react-intl'

const scope = `procurify.components.SavedFiltersForm`

export default defineMessages({
  nameRequiredError: {
    id: `${scope}.nameRequiredError`,
    defaultMessage: 'Name is required',
  },
  nameFieldPlaceholder: {
    id: `${scope}.nameFieldPlaceholder`,
    defaultMessage: 'Filter name',
  },
  nameFieldLabel: {
    id: `${scope}.nameFieldLabel`,
    defaultMessage: 'Filter name',
  },
  submitButton: {
    id: `${scope}.submitButton`,
    defaultMessage: 'Save filter',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  modalTitle: {
    id: `${scope}.modalTitle`,
    defaultMessage: 'Save filter',
  },
  deleteFilterLabel: {
    id: `${scope}.deleteFilterLabel`,
    defaultMessage: 'Delete filter',
  },
})
